/* asn1/lib/ber/index */ function _(require, module, exports) {
    // Copyright 2011 Mark Cavage <mcavage@gmail.com> All rights reserved.
    var errors = require(45) /* ./errors */;
    var types = require(48) /* ./types */;
    var Reader = require(47) /* ./reader */;
    var Writer = require(49) /* ./writer */;
    // --- Exports
    module.exports = {
        Reader: Reader,
        Writer: Writer
    };
    for (var t in types) {
        if (types.hasOwnProperty(t))
            module.exports[t] = types[t];
    }
    for (var e in errors) {
        if (errors.hasOwnProperty(e))
            module.exports[e] = errors[e];
    }
}
